import axios from "axios";
const HTTP = axios.create({
  baseURL: process.env.API + "/api/",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    xsrfCookieName: "XSRF-TOKEN", // default
    // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    xsrfHeaderName: "X-XSRF-TOKEN", // default
  },
});

const HTTPLink = axios.create({
  baseURL: "https://localhost:44392/api/link/",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
    xsrfCookieName: "XSRF-TOKEN", // default
    // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    xsrfHeaderName: "X-XSRF-TOKEN", // default
  },
});

export { HTTP, HTTPLink };
